(ns ui.wallet.credit-notes
  "The credit notes modal of the wallet page: the refunds and credits Paddle
   issued to the customer, each with a link to its PDF credit note (see
   `app.wallet.credit-notes`)."
  (:require [parts.replicant.query :as query]
            [ui.elements]
            [ui.wallet.i18n :as i18n]))

(def credit-notes-query
  {:query/kind :query/wallet-credit-notes})

(def zero-decimal-currencies
  "Paddle amounts are in the lowest denomination, which is the currency
   itself for these."
  #{"JPY" "KRW"})

(defn format-amount
  [total currency-code]
  (let [amount (js/parseInt total 10)]
    (str (if (zero-decimal-currencies currency-code)
           amount
           (.toFixed (/ amount 100) 2))
         " "
         currency-code)))

(defn row
  [{:keys [id action created-at total currency-code]}]
  [:tr {:replicant/key id}
   [:td.py-2.pr-3.text-sm.text-gray-700 (some-> created-at (subs 0 10))]
   [:td.px-3.py-2.text-sm.text-gray-700
    (if (= action "refund")
      [:i18n :credit-notes/refund]
      [:i18n :credit-notes/credit])]
   [:td.px-3.py-2.text-right.text-sm.text-gray-700
    (format-amount total currency-code)]
   [:td.py-2.pl-3.text-right.text-sm
    [:a {:href (str "/subscription/credit-notes/" id)
         :target "_blank"
         :class ["text-blue-600" "hover:underline"]}
     [:i18n :credit-notes/download]]]])

(defn body
  [w]
  (cond
    (query/loading? w credit-notes-query)
    [:p.mt-4.text-sm.text-gray-500 [:i18n :page/loading]]

    (query/error? w credit-notes-query)
    [:p.mt-4.text-sm.text-red-500 [:i18n :credit-notes/error]]

    :else
    (let [credit-notes (:credit-notes (query/get-result w credit-notes-query))]
      (if (seq credit-notes)
        [:table {:class ["mt-4" "min-w-full" "divide-y" "divide-gray-300"]}
         [:tbody.divide-y.divide-gray-200
          (map row credit-notes)]]
        [:p.mt-4.text-sm.text-gray-500 [:i18n :credit-notes/empty]]))))

(defn render
  "Modals render outside `ui.wallet.page/render`, so the modal has to
   translate itself."
  [w]
  (i18n/translate w
                  [:div
                   [:h3 {:class ui.elements/h3} [:i18n :credit-notes/title]]
                   [:p {:class (concat ui.elements/p-sm ["mt-2"])}
                    [:i18n :credit-notes/intro]]
                   (body w)]))

(def modal
  {:modal-id :modals/wallet-credit-notes-modal
   :on-load (fn [_location]
              [[:data/query credit-notes-query]])
   :render #'render})

(defn link
  [css]
  [:button
   {:type "button"
    :class css
    :on {:click [[:ui/modal-open :modals/wallet-credit-notes-modal
                  {:max-width "sm:max-w-2xl"}]]}}
   [:i18n :credit-notes/view]])
